import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {LoginService} from '@services/login/login.service';
import {map} from 'rxjs/operators';

export const tokenCheckGuard: CanActivateFn = () => {
  const login = inject(LoginService); const router = inject(Router);
  if (login.isUserLoggedIn()) return true;
  return login.restoreSession().pipe(map(ok => ok ? true : router.createUrlTree(['/login'])));
};

export const adminOnlyGuard: CanActivateFn = () => {
  const login = inject(LoginService); const router = inject(Router);
  if (login.getUserRole() === 'ADMIN') return true;
  return router.createUrlTree(['/requests']);
};
